// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A channel's session secrets. Never returned by any API, encrypted at rest,
 * and carried only in the CDO sent to VTS.
 */
export class SessionCredentials implements flatbuffers.IUnpackableObject<SessionCredentialsT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SessionCredentials {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSessionCredentials(
    bb: flatbuffers.ByteBuffer,
    obj?: SessionCredentials,
  ): SessionCredentials {
    return (obj || new SessionCredentials()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSessionCredentials(
    bb: flatbuffers.ByteBuffer,
    obj?: SessionCredentials,
  ): SessionCredentials {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SessionCredentials()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  password(): string | null;
  password(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  password(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OpenSSH private key in PEM form (`-----BEGIN OPENSSH PRIVATE KEY-----`),
   * Ed25519 or ECDSA.
   */
  privateKey(): string | null;
  privateKey(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  privateKey(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Passphrase for `private_key`, when it is encrypted.
   */
  privateKeyPassphrase(): string | null;
  privateKeyPassphrase(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  privateKeyPassphrase(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSessionCredentials(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addPassword(builder: flatbuffers.Builder, passwordOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, passwordOffset, 0);
  }

  static addPrivateKey(builder: flatbuffers.Builder, privateKeyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, privateKeyOffset, 0);
  }

  static addPrivateKeyPassphrase(
    builder: flatbuffers.Builder,
    privateKeyPassphraseOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, privateKeyPassphraseOffset, 0);
  }

  static endSessionCredentials(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSessionCredentials(
    builder: flatbuffers.Builder,
    passwordOffset: flatbuffers.Offset,
    privateKeyOffset: flatbuffers.Offset,
    privateKeyPassphraseOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SessionCredentials.startSessionCredentials(builder);
    SessionCredentials.addPassword(builder, passwordOffset);
    SessionCredentials.addPrivateKey(builder, privateKeyOffset);
    SessionCredentials.addPrivateKeyPassphrase(builder, privateKeyPassphraseOffset);
    return SessionCredentials.endSessionCredentials(builder);
  }

  unpack(): SessionCredentialsT {
    return new SessionCredentialsT(this.password(), this.privateKey(), this.privateKeyPassphrase());
  }

  unpackTo(_o: SessionCredentialsT): void {
    _o.password = this.password();
    _o.privateKey = this.privateKey();
    _o.privateKeyPassphrase = this.privateKeyPassphrase();
  }

  unpackFields(...fields: string[]): SessionCredentialsT {
    const t = new SessionCredentialsT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("password")) {
      t.password = this.password();
    }
    if (fieldSet.has("private_key")) {
      t.privateKey = this.privateKey();
    }
    if (fieldSet.has("private_key_passphrase")) {
      t.privateKeyPassphrase = this.privateKeyPassphrase();
    }
    return t;
  }
}

export class SessionCredentialsT implements flatbuffers.IGeneratedObject {
  constructor(
    public password: string | Uint8Array | null = null,
    public privateKey: string | Uint8Array | null = null,
    public privateKeyPassphrase: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const password = this.password !== null ? builder.createString(this.password!) : 0;
    const privateKey = this.privateKey !== null ? builder.createString(this.privateKey!) : 0;
    const privateKeyPassphrase =
      this.privateKeyPassphrase !== null ? builder.createString(this.privateKeyPassphrase!) : 0;

    return SessionCredentials.createSessionCredentials(
      builder,
      password,
      privateKey,
      privateKeyPassphrase,
    );
  }

  clone(): SessionCredentialsT {
    const obj = new SessionCredentialsT();
    obj.password = this.password;
    obj.privateKey = this.privateKey;
    obj.privateKeyPassphrase = this.privateKeyPassphrase;
    return obj;
  }

  equals(other: SessionCredentialsT): boolean {
    if (this.password !== other.password) return false;
    if (this.privateKey !== other.privateKey) return false;
    if (this.privateKeyPassphrase !== other.privateKeyPassphrase) return false;
    return true;
  }
}

export function verifySessionCredentials(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
